<template>
    <div class="podcast-resource"
         v-if="resource"
         href="#"
         @click.prevent.stop="action()"
         :class="`type-${resource?.data?.type}`"
         :style="`background-color: ${background_color}`">

        <div class="inner">

            <div :title="podcast_name"
                 class="image">
                <img :src="preview_url_optimized" alt="">
            </div>

            <div v-if="podcast_name" class="title">
                {{ podcast_name }}
            </div>

            <div class="owner">
                Podcast
            </div>

            <div v-if="icon" class="icon">
                <img :src="icon" alt="">
            </div>

            <div class="controls">
                <button v-if="selected"
                        class="btn btn-primary btn-lg mx-1 my-1"
                        @click.prevent.stop="showPreviewModal()">Open Podcast</button>
                <button v-if="can_edit" class="btn btn-secondary btn-lg mx-1 my-1" @click.prevent.stop="showChangeModal()">
                    <template v-if="selected">Change Podcast</template>
                    <template v-else>Add Podcast</template>
                </button>
            </div>

        </div>


        <modal v-if="change_modal.show"
               :id="utils.randomId({prefix: 'modal'})"
               :show="true"
               size="xl"
               @click.stop.prevent
               @close="hideChangeModal()">
            <template #title>
                Select a DFC Podcast
            </template>

            <template v-if="change_modal.is_ready">

                <p>
                    Choose a podcast to hear from community members and their perspectives
                    regarding a specific issue that you want to learn more about and solve.
                </p>

                <div class="form-group">
                    <input type="text" class="form-control" v-model="change_modal.search" placeholder="Search...">
                </div>

                <div class="row">
                    <div class="col-sm-4 mb-3" v-for="podcast in change_modal_filtered_podcasts" :key="podcast.id">
                        <podcast-card :podcast="podcast"
                                      :actions="change_modal.podcast_actions"
                                      :open-in-modal="true"/>
                    </div>
                </div>

                <div v-if="!change_modal_filtered_podcasts.length">
                    <p class="text-danger">Sorry, nothing found. Try some other keywords to search.</p>
                </div>


            </template>
            <template v-else>
                Loading...
            </template>

            <template #footer>
                <button v-if="can_edit"
                        type="button"
                        @click.prevent.stop="remove()"
                        class="btn btn-danger ml-auto">Clear Podcast</button>
            </template>
        </modal>


        <modal :id="utils.randomId({prefix: 'modal'})"
               ref="previewModal"
               v-if="preview_modal.show"
               :show="true"
               size="xl"
               @click.stop.prevent
               @close="hidePreviewModal()">

            <template #title>
                {{ selected.name }}
            </template>

            <iframe :src="route('embed.podcast', {slug: selected?.short_name, start: false, download: false, headless: headless, hideSidebar: hideSidebar})"
                    ref="modal"
                    @resize="fixPodcastPreviewHeight()"
                    @load="fixPodcastPreviewHeight()"
                    frameborder="0"></iframe>


<!--            <template #footer>-->
<!--                <button type="button"-->
<!--                        @click.prevent.stop="hidePreviewModal()"-->
<!--                        class="btn btn-warning mr-auto">Close</button>-->
<!--            </template>-->

        </modal>

    </div>
</template>

<script>
import utils from "@/mixins/utils";
import uploads from "@/mixins/uploads";
import Modal from "@/Components/Common/Modal";
import API from "@/API";
import PodcastCard from "@/Components/Podcast/PodcastCard";
import {mapActions} from "vuex";

export default {
    name: "CanvasPodcast",
    components: {PodcastCard, Modal},
    mixins: [utils, uploads],

    emits: ['remove-resource'],
    props: ['element', 'stage', 'path', 'canvas', 'section', 'headless', 'hideSidebar', 'editable'],


    data(){
        return {

            is_busy: false,
            selected: null,

            change_modal: {
                is_ready: false,
                show: false,
                search: '',
                podcasts: [],
                podcast_actions: {
                    select: {
                        class: 'btn-light',
                        title: 'Select',
                        action: (podcast) => this.selectPodcast(podcast),
                    }
                }
            },

            preview_modal: {
                show: false,
            }
        }
    },


    computed: {

        can_edit(){
            return this.editable && !this.podcast_is_in_path;
        },

        path_fragment_key(){
            return `stage_${this.stage}_${this.section.id}_podcast_${this.element?.id}`;
        },

        canvas_fragment_key(){
            return `stage_${this.stage}_${this.section.id}_podcast_${this.element?.id}`;
        },

        path_podcast_data(){
            return this.path?.fragments[ this.path_fragment_key ] ? this.path.fragments[ this.path_fragment_key ] : null;
        },

        canvas_podcast_data(){
            return this.canvas?.fragments[ this.canvas_fragment_key ] ? this.canvas.fragments[ this.canvas_fragment_key ] : null;
        },

        podcast_is_in_path(){
            return !!this.path_podcast_data;
        },

        podcast_is_in_canvas(){
            return !!this.canvas_podcast_data;
        },

        has_podcast(){
            return this.podcast_is_in_path || this.podcast_is_in_canvas;
        },

        podcast_data(){

            /**
             * Priority: First check in path, then in canvas
             */

            if( this.podcast_is_in_path ){
                return this.path_podcast_data;
            }else if( this.podcast_is_in_canvas ){
                return this.canvas_podcast_data;
            }

            return false;
        },

        resource(){
            return this.element?.element ? this.element.element : null;
        },

        change_modal_filtered_podcasts(){
            if( !this.change_modal.search.length ) return this.change_modal.podcasts;
            const regex = new RegExp(this.change_modal.search, 'gi');
            return this.change_modal.podcasts.filter(p => regex.test(p.name) || regex.test(p.description));
        },

        podcast_name(){
            return this.selected?.name ? this.selected.name : 'Choose a DFC podcast';
        },

        options(){
            return this.resource?.data?.options;
        },

        background_color(){
            try{ return this.resource.data.color; } catch (e){};
            return '#343a40';
        },

        preview_url_optimized(){
            let w = this.options?.width;
            w = w ? w * 320 : 320;
            return this.uploads.image(this.preview_url, {w, h: 320});
        },

        preview_url(){
            return this.selected?.picture_large ? this.selected?.picture_large : this.resource.data.file.url;
        },
    },


    watch: {},


    methods: {

        ...mapActions('repositories', { updateRepo: 'updateRepository' }),


        selectPodcast(podcast){
            this.selected = podcast;
            this.hideChangeModal();
            this.onPodcastChanged();
        },

        showPreviewModal(){
            this.preview_modal.show = true;
        },

        hidePreviewModal(){
            this.preview_modal.show = false;
        },

        async showChangeModal(){
            this.change_modal.search = '';
            this.change_modal.show = true;

            if( !this.change_modal.is_ready ){
                this.change_modal.podcasts = await API.podcasts.bulk();
            }

            this.change_modal.is_ready = true;

        },

        hideChangeModal(){
            this.change_modal.show = false;
        },

        action(){

        },

        remove(){
            if( !confirm('Are you sure to remove this resource?') ) return;

            this.selectPodcast(null);

            this.$emit('remove-resource');
            this.show_modal = false;
        },

        fixPodcastPreviewHeight(){
            if( this.$refs.previewModal.contentWindow ){
                this.$refs.previewModal.height = "";
                this.$refs.previewModal.height = this.$refs.previewModal.contentWindow.document.body.scrollHeight + "px";
            }
        },


        onPodcastChanged(){
            const fragments = {};

            fragments[this.path_fragment_key] = this.selected ? {
                podcast: {id: this.selected.id, short_name: this.selected.short_name},
            } : null;

            /**
             * Update Canvas Repo Only.
             */

            this.updateRepo({scope: this.canvas.scope, fragments});
        }

    },


    async beforeMount() {
        this.is_busy = true;

        if( this.has_podcast && this.podcast_data?.podcast?.short_name ){
            this.selected = await API.podcasts.get( this.podcast_data?.podcast?.short_name );
        }

        this.is_busy = false;
    }

}
</script>

<style lang="scss" scoped>
.podcast-resource{
    border: #FFFFFF solid 2px;
    display: block;
    color: white;
    text-decoration: none;
    position: relative;
    width: 100%;
    border-radius: 0.4rem;
    overflow: hidden;
    box-shadow: 0 2px 8px #00000029;
}

.aw-1{
    .podcast-resource{
        padding-top: 100%;
    }
}

.aw-2{
    .podcast-resource{
        padding-top: 50%;
    }
}
.aw-3{
    .podcast-resource{
        padding-top: 33.333333%;
    }
}
.aw-4{
    .podcast-resource{
        padding-top: 25%;
    }
}
.aw-5{
    .podcast-resource{
        padding-top: 20%;
    }
}
.title{
    position: relative;
    z-index: 1;
    padding: 0.5rem;
    background: rgba(white, 0.7);
    display: inline-block;
    border-radius: 0.3rem;
    color: $dark;
    backdrop-filter: blur(3px);
}
.inner{
    padding: 1rem 1rem 2.6rem 1rem;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
}

@media (min-width: 650px) and (max-width: 1199px){
    .aw-1{
        .podcast-resource{
            padding-top: 0%;
            padding-bottom: 100%;
        }
    }

    .aw-2{
        .podcast-resource{
            padding-top: 50%;
            padding-bottom: 50%;
        }
    }
    .aw-3{
        .podcast-resource{
            padding-top: 33.333333%;
            padding-bottom: 33.333333%;
        }
    }
    .aw-4{
        .podcast-resource{
            padding-top: 25%;
            padding-bottom: 25%;
        }
    }
    .aw-5{
        .podcast-resource{
            padding-top: 20%;
            padding-bottom: 20%;
        }
    }

    .title{
        position: static;
        padding: 1rem;

    }

    .inner{
        padding: 1rem;
        position: static;
    }
}
.image{
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    transition: opacity .3s;

    img{
        width: 100%;
        height: 100%;
        object-fit: cover;
        transition: filter .3s;
    }
}
.icon{
    position: absolute;
    bottom: 0.6rem;
    right: 0.6rem;
}
.owner{
    position: absolute;
    background: #ee1651;
    color: white;
    bottom: 0;
    left: 0;
    border-radius: 0 0.4rem 0 0.4rem;
    padding: 0.2rem 0.5rem;
    text-transform: uppercase;
}
.sortable-ghost{
    .podcast-resource{
        background: rgba($dark, 0.3) !important;
        border-color: $dark !important;
        > * {
            opacity: 0.5 !important;
        }
    }
}

iframe{
    width: 100%;
    height: 600px;
    height: 75vh;
}

.controls{
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0;
    transition: opacity .3s;
}

.podcast-resource{
    background: $dark;

    &:hover{
        .image{
            opacity: .3;

            img{
                filter: blur(5px);
            }
        }
        .controls{
            opacity: 1;
        }
    }
}
</style>
